import React, { useState ,useEffect} from "react";
import { ArrowUpRight, ArrowDownLeft } from "lucide-react";
import BuildCoin from "./images/buildcoin.png";
import { FaChevronLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { FiBox } from "react-icons/fi";

const BuildcoinsTrn = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("history"); // "history" or "pending"
  const [loading, setLoading] = useState(true);
  const [wallet, setWallet] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [error, setError] = useState(null);
  const [pendingInvoice, setPendingInvoice] = useState(null);
  const [pendingStatus, setPendingStatus] = useState("pending"); // "pending", "under_review", "approved", "rejected"
  const [uploading, setUploading] = useState(false);
  const consumerId = sessionStorage.getItem("customerId"); // Assuming consumer ID is stored in localStorage
  const [pqc,setPqc] = useState([]);
  console.log(pqc);
  const fileInputRef = React.useRef(null);
  // Add these states at the top
  const [showBottomSheet, setShowBottomSheet] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  console.log("selectedProject",selectedProject)

// Function to open bottom sheet
const openBottomSheet = async (category) => {
  setSelectedCategory(category);
  setShowBottomSheet(true);
};

// Function to handle file selection inside bottom sheet
const handleFileChange = (e) => {
  setSelectedFile(e.target.files[0]);
};

// Function to submit file from bottom sheet
const handleSubmitUpload = async () => {
  if (!selectedFile || !selectedCategory || !selectedProject) return;

  await handleUploadInvoice({ target: { files: [selectedFile] } }, selectedCategory._id, selectedProject);

  setShowBottomSheet(false);
  setSelectedFile(null);
  setSelectedCategory(null);
  setSelectedProject(null);
};

  useEffect(() => {
    const fetchTransactions = async () => {
      const token = sessionStorage.getItem('token');
      try {
        const res = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}rewards/get-all-transactions-for-consumer?consumer_id=${consumerId}`,
        {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      }
        );
        if (!res.ok) {
          throw new Error("Failed to fetch transactions");
        }
        const data = await res.json();
        console.log("Fetched transactions data:", data);
        setWallet(data.wallet);
        setTransactions(data.transactions);
      } catch (err) {
        console.error("Error fetching transactions:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    const fetchAllCategories = async () => {
      const token = sessionStorage.getItem('token');
      try {
        const res = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}product-category/get-all-productCategories`,
        {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      }
        );
        if (!res.ok) {
          throw new Error("Failed to fetch categories");
        }
        const data = await res.json();
        console.log("Fetched categories data:", data);
        if (data?.data && Array.isArray(data.data)) {
          const filteredCategories = data.data.filter(cat => cat.is_project_quote === true);
          setPqc(filteredCategories);
        }
      } catch (err) {
        console.error("Error fetching categories:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

      const fetchAllProjects = async () => {
      const token = sessionStorage.getItem('token');
        try {
          const token = sessionStorage.getItem("token");
          const res = await fetch(`${process.env.REACT_APP_FORE_APILINK}/projects/get-projects-by-customer?customer_id=${consumerId}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", "x-token": token },
          });
          const data = await res.json();
          console.log("Fetched projects:", data);
          if (data.success) {
            setProjects(data.data || []);
          }
        } catch (err) {
          console.error("Failed to fetch projects", err);
        }finally {
              setLoading(false);
            }
    };

    fetchTransactions();
    fetchAllCategories();
    fetchAllProjects();
  }, [consumerId]);


useEffect(() => {
if (projects.length && activeTab === "pending") {
    fetchAllInvoiceStatuses();
  }
}, [projects,activeTab, consumerId]);

const fetchAllInvoiceStatuses = async () => {
  setUploading(true);
  setError(null);
  const token = sessionStorage.getItem("token");
  try {
    const res = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}rewards/get-all-bcr-invoice-statuses?consumer_id=${consumerId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );
    const data = await res.json();
    console.log("Fetched invoice statuses:", data);

    if (data.success && Array.isArray(data.invoices)) {
      setPqc(prev =>
        prev.map(cat => {
          const inv = data.invoices.find(i => i.category_id === cat._id); // ✅ fixed key match
          let projectName = null;

          if (inv && inv.project_id) {
            // Find project name from projects array
            const proj = projects.find(p => p._id === inv.project_id);
            projectName = proj ? proj.projectName : "Unknown Project";
            console.log("Matched project:", proj);
          }
          return {
            ...cat,
            pendingInvoice: inv ? { name: inv.filename } : null,
            pendingStatus: inv ? inv.status : "pending",
            currentProjectName: projectName,
            uploading: false,
            error: null,
          };
        })
      );
    }
  } catch (err) {
    console.error("Failed to fetch invoice statuses", err);
    setError("Failed to fetch invoice statuses");
  } finally {
    setUploading(false);
  }
};


const navigateToOrderDeatils = (quotationId) => {
  console.log(quotationId)
  navigate('/consumer/app/orderdetails', {
      state: { quotationId: quotationId },
    });
}

const handleUploadInvoice = async (e, category_id) => {
  const file = e.target.files[0];
  if (!file) return;

  const token = sessionStorage.getItem("token");
  const formData = new FormData();
  formData.append("invoice", file);
  formData.append("consumer_id", consumerId);
  formData.append("category_id", category_id);
  formData.append("project_id", selectedProject);
  setPqc(prev =>
    prev.map(cat =>
      cat._id === category_id ? { ...cat, uploading: true, error: null } : cat
    )
  );

  try {
    const res = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}rewards/upload-bcr-invoice`,
      { method: "POST", headers: { "x-token": token }, body: formData }
    );
    const data = await res.json();

    if (data.success) {
      // ✅ refresh statuses from backend
      fetchAllInvoiceStatuses();
    } else {
      setPqc(prev =>
        prev.map(cat =>
          cat._id === category_id
            ? { ...cat, uploading: false, error: data.message || "Upload failed" }
            : cat
        )
      );
    }
  } catch (err) {
    setPqc(prev =>
      prev.map(cat =>
        cat._id === category_id
          ? { ...cat, uploading: false, error: "Upload failed" }
          : cat
      )
    );
  }
};



const resetInvoice = async (category_id) => {
  setPqc(prev =>
    prev.map(cat =>
      cat._id === category_id
        ? { ...cat, pendingInvoice: null, pendingStatus: "pending", error: null }
        : cat
    )
  );

  // re-fetch statuses from backend
  await fetchAllInvoiceStatuses();
};


  // Filter transactions by tab
/*   const filteredTransactions = transactions.filter(
    (txn) => txn ? activeTab === "history" : activeTab === "pending"
  ); */

  const filteredTransactions = activeTab === "history"
  ? transactions
  : []; // No pending transactions from API, show custom card

 return (
  <div className="flex flex-col min-h-screen bg-gray-50">
    {/* Header */}
    <div className="p-4 bg-white shadow-sm">
      <div className="flex items-center mb-4">
        <button
          onClick={() => navigate(-1)}
          className="p-2 mr-3 rounded-full hover:bg-gray-100 transition" 
        >
          <FaChevronLeft className="text-gray-700 text-base" />
        </button>
        <h1 className="text-lg font-bold text-gray-900">BuildCoins Wallet</h1>
      </div>

      {/* Balance Card */}
      <div className="bg-white rounded-xl p-5 shadow-md flex flex-col items-center">
        <p className="text-sm text-gray-500">Current Balance</p>
        <div className="flex items-center mt-2">
          <img src={BuildCoin} alt="BuildCoin" className="w-7 h-6" />
          <p className="text-3xl font-extrabold text-gray-900 ml-2">
            {wallet?.available_coins || 0}
          </p>
        </div>
        <p className="text-xs text-gray-400 mt-1">1 BuildCoin = ₹1</p>
      </div>

      {/* Tabs */}
      <div className="flex mt-4 bg-white rounded-xl shadow-sm overflow-hidden">
        {["history", "pending"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`flex-1 py-3 text-sm font-semibold ${
              activeTab === tab
                ? "bg-red-500 text-white"
                : "bg-gray-100 text-gray-600"
            }`}
          >
            {tab === "history" ? "History" : "Pending"}
          </button>
        ))}
      </div>
    </div>

    {/* Transactions */}
    <div className="flex-1 overflow-y-auto p-4">
      {activeTab === "history" &&
        (filteredTransactions.length ? (
          filteredTransactions.map((txn, idx) => (
            <div
              key={txn._id}
              className="bg-white rounded-xl p-4 mb-3 shadow-sm flex"
            >
              {/* Indicator */}
              <div className="mt-1 mr-3 items-center flex flex-col">
                {txn.transaction_type === "credit" ? (
                  <ArrowDownLeft className="text-green-500 w-5 h-5" />
                ) : (
                  <ArrowUpRight className="text-red-500 w-5 h-5" />
                )}
                {idx !== filteredTransactions.length - 1 && (
                  <div className="w-px flex-1 bg-gray-300 mt-1" />
                )}
              </div>

              {/* Transaction Details */}
              <div className="flex-1">
                <div className="flex justify-between items-center">
                  <p className="font-semibold text-gray-900 capitalize">
                    {txn.transaction_type}
                  </p>
                  <div className="flex items-center">
                    <p
                      className={`font-semibold ${
                        txn.transaction_type === "credit"
                          ? "text-green-600"
                          : "text-red-600"
                      }`}
                    >
                      {txn.transaction_type === "credit"
                        ? `+${txn.build_coins}`
                        : `-${txn.build_coins}`}
                    </p>
                    <img
                      src={BuildCoin}
                      alt="coin"
                      className="w-6 h-5 ml-1"
                    />
                  </div>
                </div>
                <p className="text-xs text-gray-400 mt-1">
                  {new Date(txn.createdAt).toLocaleString("en-IN", {
                    timeZone: "Asia/Kolkata",
                    year: "numeric",
                    month: "short",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })}
                </p>
                {txn.desc && (
                  <p className="text-sm text-gray-500 mt-1">{txn.desc}</p>
                )}

                {/* Product Card */}
                {txn.order && (
                  <div
                    onClick={() =>
                      navigateToOrderDeatils(txn.order.quotationId)
                    }
                    className="mt-3 bg-gray-50 rounded-lg p-3 flex items-center border border-dashed border-gray-200 cursor-pointer hover:bg-gray-100"
                  >
                    {txn.order.image ? (
                      <img
                        src={txn.order.image}
                        alt={txn.order.orderNumber}
                        className="w-16 h-16 rounded object-cover"
                      />
                    ) : (
                      <div className="w-16 h-16 bg-gray-100 rounded flex items-center justify-center">
                        <FiBox className="text-gray-400 text-xl" />
                      </div>
                    )}
                    <div className="ml-3 flex-1">
                      <p className="font-medium text-base">
                        {txn.order.orderNumber}
                      </p>
                      <p className="text-sm text-gray-600">
                        ₹{txn.order.totalAmount + txn.order.discount}
                      </p>
                      <p
                        className={`text-xs mt-1 ${
                          txn.transaction_type === "credit"
                            ? "text-green-700"
                            : "text-yellow-700"
                        }`}
                      >
                        {txn.transaction_type === "credit"
                          ? `Earned ${txn.build_coins} coins`
                          : `Saved ₹${txn.order.discount}`}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <p className="text-center text-gray-400 mt-10">
            No transactions yet
          </p>
        ))}

      {/* Pending */}
      {activeTab === "pending" && pqc?.length > 0 && (
        <div className="space-y-4">
          {pqc.map((category) => (
            <div
              key={category.product_category_id}
              className="border-b border-gray-200 pb-4 last:border-b-0"
            >
              {/* Category header */}
              <div className="flex items-center gap-3 mb-2">
                <ArrowDownLeft className="w-6 h-6 text-yellow-500" />
                <div>
                  <p className="font-semibold text-base">{category.product_category_name}</p>
                  {/* {console.log(category)} */}
                  {category.currentProjectName && (
                  <p className="text-sm text-gray-600">
                    Current Project: <span className="font-medium">{category.currentProjectName}</span>
                  </p>
                  )}
                  <p className="text-sm text-gray-500">
                    Upload your invoice to claim BuildCoins for this category.
                  </p>
                  <p className="text-xs text-gray-400">
                    {category.pendingStatus === "pending"
                      ? "Waiting for invoice upload"
                      : category.pendingStatus === "under_review"
                      ? "Invoice under review"
                      : category.pendingStatus === "approved"
                      ? "Approved! Coins credited."
                      : "Rejected. Please upload again."}
                  </p>
                </div>
              </div>

              {/* Invoice upload / status card */}
              <div className=" m-3 border border-dashed border-gray-300 rounded-lg p-3 flex flex-col gap-3 bg-gray-50">
                {!category.pendingInvoice ? (
                  <div className="flex flex-col items-center">{
                    console.log(category)
                  }
{/*                     <input
                      type="file"
                      accept="image/*,.pdf"
                      id={`invoice-upload-${category._id}`}
                      style={{ display: "none" }}
                      onChange={(e) => handleUploadInvoice(e, category._id)}
                      disabled={category.pendingStatus !== "pending"}
                    />
                    <label
                      htmlFor={`invoice-upload-${category._id}`}
                      className={`inline-block px-5 py-2 bg-red-500 text-white rounded-md font-semibold shadow hover:bg-red-600 transition-colors cursor-pointer ${
                        category.uploading ||
                        !["pending", "approved", "rejected"].includes(category.pendingStatus)
                          ? "opacity-50 cursor-not-allowed pointer-events-none"
                          : ""
                      }`}
                    >
                      {category.uploading ? "Uploading..." : "Upload Invoice"}
                    </label> */}
                    <button
                    onClick={() => openBottomSheet(category)}
                    className={`inline-block px-5 py-2 bg-red-500 text-white rounded-md font-semibold shadow hover:bg-red-600 transition-colors`}
                  >
                    Upload Invoice
                  </button>

                    {category.error && (
                      <p className="text-xs text-red-500 mt-2">{category.error}</p>
                    )}
                  </div>
                ) : (
                  <div className="flex items-center gap-3">
                    <div className="w-16 h-16 flex items-center justify-center bg-gray-100 rounded">
                      {category.pendingInvoice?.name ? (
                        <img
                          src={`${process.env.REACT_APP_FORE_BRICKBUCKET}${category.pendingInvoice.name}`}
                          alt="Uploaded Invoice"
                          className="w-12 h-12 object-cover rounded-md"
                        />
                      ) : (
                        <FiBox className="text-gray-500 text-2xl" />
                      )}
                    </div>
                    <div>
{/*                       <p className="font-medium break-all">{category.pendingInvoice.name}</p>
 */}                      <p className="text-xs text-yellow-800">
                        {category.pendingStatus === "under_review"
                          ? "Invoice uploaded, under review"
                          : category.pendingStatus === "approved"
                          ? "Invoice approved! Coins credited."
                          : "Invoice rejected. Please upload again."}
                      </p>

                      {(category.pendingStatus === "approved" ||
                        category.pendingStatus.toLowerCase() === "rejected") && (
                        <button
                          className={`mt-2 px-4 py-1 rounded font-semibold shadow transition-colors ${
                            category.pendingStatus === "approved"
                              ? "bg-green-500 text-white hover:bg-green-600"
                              : "bg-red-500 text-white hover:bg-red-600"
                          }`}
                          onClick={() => openBottomSheet(category)}
                        >
                          Upload Again
                        </button>
                      )}
                    </div>
                  </div>
                )}

                {/* Status message below card */}
                {category.pendingStatus === "under_review" && (
                  <p className="text-xs text-blue-600 font-semibold text-center">
                    Your invoice is under review. You will be notified once it is approved or rejected.
                  </p>
                )}
                {category.pendingStatus === "approved" && (
                  <p className="text-xs text-green-600 font-semibold text-center">
                    Invoice approved! BuildCoins have been credited to your wallet.
                  </p>
                )}
                {category.pendingStatus === "rejected" && (
                  <p className="text-xs text-red-600 font-semibold text-center">
                    Invoice rejected. Please upload a valid invoice.
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>

    {/* Bottom Sheet (Upload Invoice) */}
    {showBottomSheet && (
      <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/30">
        <div className="w-full bg-white rounded-t-2xl p-4 max-h-[70vh] overflow-y-auto shadow-lg">
          <h2 className="text-lg font-semibold mb-4">Upload Invoice</h2>

          {/* Project Dropdown */}
          <div className="mb-4">
            <label className="block mb-1 font-medium">Select Project</label>
            <select
              value={selectedProject}
              onChange={(e) => setSelectedProject(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:ring-1 focus:ring-red-400"
            >
              <option value="">-- Select Project --</option>
              {projects.map((proj) => (
                <option key={proj._id} value={proj._id}>
                  {proj.projectName}
                </option>
              ))}
            </select>
          </div>

          {/* File Upload */}
          <div className="mb-4">
            <label className="block mb-1 font-medium">Select Invoice</label>
            <input
              type="file"
              accept="image/*,.pdf"
              onChange={handleFileChange}
              className="w-full border border-gray-300 rounded px-3 py-2"
            />
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-3">
            <button
              onClick={() => setShowBottomSheet(false)}
              className="px-4 py-2 bg-gray-200 rounded-md"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmitUpload}
              disabled={!selectedFile || !selectedProject}
              className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 disabled:opacity-50"
            >
              Upload
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
);


};

export default BuildcoinsTrn;
